import React, { useEffect, useState } from "react";
import { ProgressBar, Button, Modal } from "react-onsenui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Cookies from 'js-cookie';
import { DocumentPdf } from "grommet-icons";
import { BASE_URL } from "../apiService";
import CameraScreen from "./CameraScreen";
import Stage1Content from "./stageContent/Stage1Content";
import Stage2Content from "./stageContent/Stage2Content";
import Stage3Content from "./stageContent/Stage3Content";
import Stage4Content from "./stageContent/Stage4Content";
import Stage5Content from "./stageContent/Stage5Content";
import Stage6Content from "./stageContent/Stage6Content";

const UploadClaimStatus = ({ navigator }) => {
  const [loading, setLoading] = useState(false);
  const [stage, setStage] = useState(1);
  const [claim, setClaim] = useState(null);
  const [cameraModalVis, setCameraModalVis] = useState(false);
  const [uploadType, setUploadType] = useState(null);
  const [docName, setDocName] = useState(null);
  const [focusedExtraImageID, setFocusedExtraImageID] = useState(null);
  const [isPreviewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const [itemsToSync, setItemsToSync] = useState(0);

  useEffect(() => {
    fetchClaimData();
    fetchSyncCount();
  }, []);




  const fetchClaimData = async () => {
    setLoading(true);
    const isOnline = window.navigator.onLine;
  
    if (isOnline) {
      try {
        const cid= Cookies.get('CLAIM_NUMBER')
        const response = await axios.post(`${BASE_URL}/claims-by-id`, { claimId: cid });
        const claimData = response.data.data;
  
        if (claimData) {
          setClaim({ ...claimData, id: claimData?._id });
          console.log('Fetched claimData:', { ...claimData, id: claimData?._id });
  
          // Save data to IndexedDB for offline use
          await saveClaimToIndexedDB(claimData);
        }
      } catch (error) {
        console.error("Error fetching claim data from API:", error);
      } finally {
        setLoading(false);
      }
    } else {
      console.log('Offline mode, attempting to retrieve claim from IndexedDB');
      try {
        const db = await openDB();
        const tx = db.transaction("claims", "readonly");
        const store = tx.objectStore("claims");
        const cid= Cookies.get('CLAIM_NUMBER')
        const offlineClaimRequest = store.get(cid);
  
  // Await the result of the request
  const offlineClaim = await new Promise((resolve, reject) => {
    offlineClaimRequest.onsuccess = () => resolve(offlineClaimRequest.result);
    offlineClaimRequest.onerror = () => reject(offlineClaimRequest.error);
  });
  
  console.warn('Retrieved offlineClaim:', offlineClaim);
  
        if (offlineClaim) {
          setClaim(offlineClaim);
          console.log("Loaded claim from IndexedDB:", offlineClaim);
        } else {
          console.warn("No offline claim data found.");
        }
      } catch (error) {
        console.error("Error loading claim data from IndexedDB:", error);
      } finally {
        setLoading(false);
      }
    }
  };


  useEffect(() => {
    fetchClaimData();
    fetchSyncCount();
  }, [cameraModalVis]); // Empty dependency array ensures the effect runs only on mount and unmount

  
  
  const saveClaimToIndexedDB = async (claimData) => {
    try {
      // Open the IndexedDB database
      const db = await openDB();
  
      // Start a readwrite transaction on the `claims` object store
      const tx = db.transaction("claims", "readwrite");
      const store = tx.objectStore("claims");
  
      // Add or update the claim data in IndexedDB
      const putRequest = store.put(claimData);
  
      // Use a promise to handle the success or error of the request
      await new Promise((resolve, reject) => {
        putRequest.onsuccess = () => {
          console.log("Claim data saved to IndexedDB:", claimData);
          resolve();
        };
        putRequest.onerror = (event) => {
          console.error("Error saving claim data to IndexedDB:", event.target.error);
          reject(event.target.error);
        };
      });
    } catch (error) {
      console.error("Error saving claim data to IndexedDB:", error);
    }
  };
  
  

  const fetchSyncCount = async () => {
    try {
      // Open the IndexedDB database
      const db = await openDB();
  
      // Start a readonly transaction on the `claim-images` object store
      const tx = db.transaction("claim-images", "readonly");
      const store = tx.objectStore("claim-images");
  
      // Count the number of entries in the object store
      const count = await new Promise((resolve, reject) => {
        const countRequest = store.count();
  
        countRequest.onsuccess = () => resolve(countRequest.result);
        countRequest.onerror = () => reject(countRequest.error);
      });
  
      // Log and update the count
      console.log('Items to sync:', count);
      setItemsToSync(count);
    } catch (error) {
      console.error("Error fetching sync count:", error);
    }
  };
  

  const uploadImage = async (blob) => {
    try {
      const base64Data = await blobToBase64(blob);
      const payload = {
        isPdf: false,
        fileName: "DUMMY_NAME",
        base64Data: base64Data.split(",")[1],
        userId: claim?.ownerId,
      };
      const response = await axios.post(`${BASE_URL}/get-gcp-url`, payload);
      return response.data.response.Location;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  };


  
  const syncPendingItems = async () => {
    try {
      const db = await openDB();
      const tx = db.transaction("claim-images", "readonly");
      const store = tx.objectStore("claim-images");
  
      // Retrieve all items from the object store
      const items = await new Promise((resolve, reject) => {
        const getAllRequest = store.getAll();
  
        getAllRequest.onsuccess = () => resolve(getAllRequest.result);
        getAllRequest.onerror = () => reject(getAllRequest.error);
      });
  
      if (!Array.isArray(items)) {
        console.error("Retrieved items is not an array:", items);
        return;
      }
  
      // Iterate over items and sync each one
      let internetConnectionNotThere=false;
      for (const item of items) {
        setLoading(true);
        try {
          // Upload image and get the storage URL
          const storageUrl = await uploadImage(item.blob);
  
          // Send the data to the server
          await axios.patch(`${BASE_URL}/claims`, {
            userId: item.userId,
            claimId: item.claimId,
            storageUrl,
            title: item.title,
            extraImageID: item.extraImageID,
          });
  
          // Delete the synced item from the object store
          const deleteTx = db.transaction("claim-images", "readwrite");
          const deleteStore = deleteTx.objectStore("claim-images");
          await new Promise((resolve, reject) => {
            const deleteRequest = deleteStore.delete(item.id);
  
            deleteRequest.onsuccess = () => resolve();
            deleteRequest.onerror = () => reject(deleteRequest.error);
          });
  
          console.log(`Successfully synced and deleted item with ID: ${item.id}`);
        } catch (syncError) {
        
          if(syncError.code==="ERR_NETWORK"){
            internetConnectionNotThere=true;
          
          }
          console.error("Error syncing item:", syncError);
        }
      }
      if(internetConnectionNotThere){
        alert("Please check your internet connection  ")
      }
  
      // Refresh the sync count
      await fetchSyncCount();
      await fetchClaimData();
    } catch (error) {
      console.error("Error syncing items:", error);
    }finally{
      setLoading(false)
    }
  };
  


  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const handleDocPreview = (url) => {
    setPreviewImageUrl(url);
    setPreviewModalVisible(true);
  };

  const closePreviewModal = () => {
    setPreviewModalVisible(false);
    setPreviewImageUrl(null);
  };

  const incrementSyncCounter = async () => {
    try {
      const db = await openDB();
      const tx = db.transaction("claim-images", "readwrite");
      const store = tx.objectStore("claim-images");
      const count = await store.count();
      setItemsToSync(count + 1);
    } catch (error) {
      console.error("Error incrementing sync counter:", error);
    }
  };

  const renderStageContent = (stage) => {
    const commonProps = {
      claim,
      setUploadType,
      setDocName,
      setCameraModalVis,
      setFocusedExtraImageID,
      handleDocPreview,
      navigator,
    };

    switch (stage) {
      case 1:
        return <Stage1Content {...commonProps} />;
      case 2:
        return <Stage2Content {...commonProps} />;
      case 3:
        return <Stage3Content {...commonProps} />;
      case 4:
        return <Stage4Content {...commonProps} />;
      case 5:
        return <Stage5Content {...commonProps} />;
      case 6:
        return <Stage6Content {...commonProps} />;
      default:
        return null;
    }
  };



  return (
    <div style={{ padding: "0px" }}>
      {/* {loading && <ProgressBar indeterminate style={{ height: 10 }} />} */}
      {cameraModalVis && (
        <CameraScreen
        fetchSyncCount={fetchSyncCount}
          setFocusedExtraImageID={setFocusedExtraImageID}
          focusedExtraImageID={focusedExtraImageID}
          uploadType={uploadType}
          docName={docName}
          claim={claim}
          uploadImage={uploadImage}
          navigator={navigator}
          setCameraModalVis={setCameraModalVis}
          incrementSyncCounter={incrementSyncCounter}
        />
      )}

      <div style={{ position: "absolute", top: 10, right: 10, zIndex: 1000 }}>
      {itemsToSync>0 &&  <Button onClick={syncPendingItems} style={{background:"#5C7232"}}>
          <FontAwesomeIcon icon={faSyncAlt} size="lg" />
          {itemsToSync > 0 && (
            <span style={{ marginLeft: 8, fontWeight: "bold", color: "white" }}>
              {itemsToSync}
            </span>
          )}
        </Button>}
      </div>

      <div className="mt-2 mb-2" style={{ cursor: "pointer" }}>
        Claim Number - <b>{claim?.applicationNumber}</b> &nbsp;
        {/* <DocumentPdf color="#5C7232" /> */}
      </div>

      <div style={{ marginTop: "20px" }}>{renderStageContent(stage)}</div>

      {isPreviewModalVisible && (
        <Modal isOpen={isPreviewModalVisible} animation="fade">
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.9)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
              zIndex: 1000,
            }}
          >
            <img
              src={previewImageUrl}
              alt="Document Preview"
              style={{ maxWidth: "100%", maxHeight: "100%", borderRadius: "8px" }}
            />
            <Button
              onClick={closePreviewModal}
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              <FontAwesomeIcon icon={faTimes} color="#fff" size="2x" />
            </Button>
          </div>
        </Modal>
      )}


         <Modal isOpen={loading} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <div style={{ background: "#5C7232", padding: "20px", borderRadius: "10px",width:'50%',marginLeft:'30%' }}>
                <div className="spinner-border" role="status" style={{ width: "3rem", height: "3rem" }}>
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </Modal>
    </div>
  );
};

export default UploadClaimStatus;

function openDB() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open("ClaimSyncDB", 1);
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains("claim-images")) {
          db.createObjectStore("claim-images", { keyPath: "id", autoIncrement: true });
        }
        if (!db.objectStoreNames.contains("claims")) {
          db.createObjectStore("claims", { keyPath: "_id" });
        }
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = (event) => reject(event.target.error);
    });
  }
  
